// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as OrderStage from "../entities/OrderStage.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as TicketStatus from "../../../../to-be-migrated/domain/types/order/tickets/TicketStatus.bs.js";
import * as TicketApiModel from "../api-model/TicketApiModel.bs.js";
import * as TicketRaisedBy from "../entities/TicketRaisedBy.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function decodeTicketCaseComments(comment) {
  return List.map((function (e) {
                return {
                        body: e.body,
                        author: e.author,
                        created_at: e.created_at
                      };
              }), comment);
}

function decodeIssueBrief(brief) {
  return {
          schema_version: brief.schema_version,
          generated_at: Belt_Option.map(brief.generated_at, Timestamp$Catalyst.make),
          pointers: {
            whom_to_call: {
              party: brief.pointers.whom_to_call.party,
              clear: brief.pointers.whom_to_call.clear,
              line: brief.pointers.whom_to_call.line,
              name: brief.pointers.whom_to_call.name,
              phone: brief.pointers.whom_to_call.phone
            },
            why_escalated: {
              clear: brief.pointers.why_escalated.clear,
              line: brief.pointers.why_escalated.line
            },
            history: {
              clear: brief.pointers.history.clear,
              line: brief.pointers.history.line
            },
            whats_expected: {
              clear: brief.pointers.whats_expected.clear,
              line: brief.pointers.whats_expected.line
            }
          },
          coverage: {
            level: brief.coverage.level,
            basis: brief.coverage.basis
          },
          start_here: Belt_Option.map(brief.start_here, (function (sh) {
                  return {
                          probe: sh.probe
                        };
                }))
        };
}

function decodeIssueBriefOption(brief) {
  if (brief !== undefined && brief.schema_version === 1) {
    return decodeIssueBrief(brief);
  }
  
}

function decodeTicket(ticket) {
  var raisedBy = ticket.raised_by;
  return {
          crn: ticket.crn,
          msisdn: ticket.msisdn,
          mobile: ticket.caller_number,
          geo_region: ticket.city,
          case_number: ticket.case_number,
          status: TicketStatus.fromString(ticket.status),
          ticket_type: ticket.type_,
          raised_at: Timestamp$Catalyst.make(ticket.created_date),
          raised_by: raisedBy !== undefined ? TicketRaisedBy.nonOptionalFromString(raisedBy) : undefined,
          author: ticket.author,
          escalate_to: ticket.escalate_to,
          order_stage: OrderStage.fromString(ticket.order_stage),
          issues: ticket.issues,
          actions: ticket.actions_taken,
          action_comment: ticket.action_comment,
          issue_comment: ticket.issue_comment,
          case_comments: decodeTicketCaseComments(ticket.case_comments),
          issue_brief: decodeIssueBriefOption(ticket.issue_brief)
        };
}

function decodeResponse(res) {
  return decodeTicket(res.data);
}

function execute(json) {
  var res = DeccoUtils$Catalyst.resolveResult(TicketApiModel.t_decode(json), "TicketApiModel.re");
  return decodeTicket(res.data);
}

var supportedIssueBriefSchemaVersion = 1;

export {
  decodeTicketCaseComments ,
  supportedIssueBriefSchemaVersion ,
  decodeIssueBrief ,
  decodeIssueBriefOption ,
  decodeTicket ,
  decodeResponse ,
  execute ,
  
}
/* TicketApiModel Not a pure module */
